import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { TextLink } from '@techstyle/react-components';
import { FormattedMessage } from '@techstyle/react-intl';

import { Header } from '../../styles/header';
import { Paragraph } from '../../styles/paragraph';

const Wrapper = styled.div``;

const TextWrapper = styled.div`
  max-width: 256px;
`;

const Title = styled(Header).attrs({
  level: 2,
})`
  font-size: 36px;
  font-weight: 500;
  text-align: center;
`;

const Body = styled(Paragraph)`
  font-size: 18px;
  line-height: 1.5;
  text-align: center;
`;

const HomeLink = styled(TextLink)`
  font-size: 18px;
  line-height: 1.5;
  color: ${props => props.theme.colors.active};
`;

export default function ErrorPageLayout({ statusCode }) {
  const homeLink = (
    <HomeLink href="/">
      <FormattedMessage defaultMessage="home" id="site_error.home_link" />
    </HomeLink>
  );

  const renderMessage = () => {
    switch (statusCode) {
      case 404:
        return (
          <FormattedMessage
            defaultMessage="We couldn't find that page. Please go {homeLink} and try again."
            id="site_error.error_page_body_404"
            values={{ homeLink }}
          />
        );

      default:
        return (
          <FormattedMessage
            defaultMessage="An unexpected error has occurred. Please go {homeLink} and try again."
            id="site_error.error_page_body_default"
            values={{ homeLink }}
          />
        );
    }
  };

  return (
    <Wrapper>
      <TextWrapper>
        <Title>
          <FormattedMessage
            defaultMessage="Uh-Oh"
            id="site_error.error_page_title"
          />
        </Title>
        <Body>{renderMessage()}</Body>
      </TextWrapper>
    </Wrapper>
  );
}

ErrorPageLayout.propTypes = {
  statusCode: PropTypes.number,
};
